import React, {PropTypes} from 'react';
import IconSVG from 'svg-inline-react';
import classNames from 'classnames';
import ShallowCompare from 'react-addons-shallow-compare';

import './IconControl.scss';

const ICON_NAMES = [
    'rightArrow',
    'leftArrow',
];

const ICON_SIZES = ['s', 'm', 'l'];

class IconsControl extends React.Component {

    static propTypes = {
        name: React.PropTypes.oneOf(ICON_NAMES),
        size: React.PropTypes.oneOf(ICON_SIZES),
        className: React.PropTypes.string,
    }

    static defaultProps = {
        size: 's',
    }

    shouldComponentUpdate(nextProps, nextState) {
        return ShallowCompare(this, nextProps, nextState);
    }

    render() {
        var iconClassName = classNames(
            'IconControl',
            ['IconControl-' + this.props.size],
            {
                ['IconControl-' + this.props.name]: this.props.name,
            },
            this.props.className,
        );
        return (
            <IconSVG src={require(`!svg-inline!./svg/${this.props.name}.svg`)}
                className={iconClassName} />
        );
    }
}

export default IconsControl;



// WEBPACK FOOTER //
// ./client/components/IconControl/IconControl.js